import React from "react";
import { Button } from "@/components/ui/button";

export function VendorMatchCard({ receipt, onRefresh, onAssign, onCreate }) {
  const vm = receipt.vendor_match;
  const ar = receipt.analysis_result || {};
  const isAssigned = !!receipt.supplier_id;
  const auto = vm?.auto_match;
  const candidates = vm?.candidates || [];
  const nonAutoCandidates = auto
    ? candidates.filter((c) => c.contact_id !== auto.contact_id)
    : candidates;

  return (
    <div
      className="mt-4 pt-3 border-t border-slate-200"
      data-testid="vendor-match-card"
    >
      <div className="flex items-center justify-between mb-2">
        <div className="text-xs font-semibold text-slate-700 flex items-center gap-2">
          🔍 Lieferanten-Erkennung
          <span className="text-slate-400 font-normal">
            (OCR-Vendor: <em>{ar.merchant_name}</em>)
          </span>
        </div>
        <Button
          type="button"
          size="sm"
          variant="ghost"
          onClick={onRefresh}
          data-testid="vendor-match-refresh"
          className="text-xs"
        >
          Erneut prüfen
        </Button>
      </div>

      {isAssigned && auto && auto.contact_id === receipt.supplier_id && (
        <div
          className="rounded-md border border-emerald-300 bg-emerald-50 px-3 py-2 text-sm flex items-center gap-2"
          data-testid="vendor-match-assigned"
        >
          <span className="text-emerald-700">✓</span>
          <span className="text-emerald-800">
            Auto-zugewiesen: <strong>{auto.name}</strong>{" "}
            <span className="text-emerald-700/80 text-xs">
              (Score {(auto.score * 100).toFixed(0)}%)
            </span>
          </span>
          {vm.suggested_account && (
            <span className="ml-auto text-xs text-emerald-700">
              Konto-Vorschlag aus Historie:{" "}
              <strong>{vm.suggested_account}</strong>
            </span>
          )}
        </div>
      )}

      {!isAssigned && auto && (
        <div
          className="rounded-md border border-indigo-300 bg-indigo-50 px-3 py-2 text-sm"
          data-testid="vendor-match-suggestion"
        >
          <div className="flex items-center justify-between flex-wrap gap-2">
            <div>
              Vorschlag: <strong>{auto.name}</strong>{" "}
              <span className="text-slate-500 text-xs">
                (Score {(auto.score * 100).toFixed(0)}%)
              </span>
            </div>
            <Button
              type="button"
              size="sm"
              onClick={() => onAssign(auto.contact_id)}
              data-testid={`vendor-match-assign-${auto.contact_id}`}
            >
              Zuweisen
            </Button>
          </div>
        </div>
      )}

      {!auto && candidates.length === 0 && (
        <div
          className="rounded-md border border-amber-300 bg-amber-50 px-3 py-2 text-sm flex items-center justify-between gap-2 flex-wrap"
          data-testid="vendor-match-not-found"
        >
          <span className="text-amber-900">
            Kein Lieferant im System gefunden.
          </span>
          <Button
            type="button"
            size="sm"
            onClick={onCreate}
            data-testid="vendor-match-create-button"
          >
            + Lieferant aus Beleg anlegen
          </Button>
        </div>
      )}

      {!auto && candidates.length > 0 && (
        <div
          className="rounded-md border border-slate-200 bg-slate-50 px-3 py-2 text-sm"
          data-testid="vendor-match-candidates"
        >
          <div className="text-xs text-slate-600 mb-2">
            Mögliche Treffer (kein Auto-Match — Score zu niedrig):
          </div>
          <ul className="space-y-1 mb-2">
            {candidates.map((c) => (
              <li
                key={c.contact_id}
                className="flex items-center justify-between gap-2"
                data-testid={`vendor-candidate-${c.contact_id}`}
              >
                <span>
                  {c.name}{" "}
                  <span className="text-slate-400 text-xs">
                    ({(c.score * 100).toFixed(0)}%)
                  </span>
                </span>
                <Button
                  type="button"
                  size="sm"
                  variant="outline"
                  onClick={() => onAssign(c.contact_id)}
                >
                  Wählen
                </Button>
              </li>
            ))}
          </ul>
          <Button
            type="button"
            size="sm"
            variant="ghost"
            onClick={onCreate}
            data-testid="vendor-match-create-button"
            className="text-xs"
          >
            + Stattdessen neuen anlegen
          </Button>
        </div>
      )}

      {nonAutoCandidates.length > 0 && auto && !isAssigned && (
        <div className="mt-2 text-[11px] text-slate-500" data-testid="vendor-match-other-candidates">
          Weitere: {nonAutoCandidates.map((c) => `${c.name} (${(c.score * 100).toFixed(0)}%)`).join(" · ")}
        </div>
      )}
    </div>
  );
}
